import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a money value with rupee symbol.
 * Shows up to 2 decimals only when needed — 6.75 -> "₹6.75", 100 -> "₹100",
 * 6.5 -> "₹6.50" (padded to 2 dp because it has a fractional part).
 * Never rounds a fractional price to an integer.
 */
export function formatMoney(v) {
    const n = Number(v);
    if (!isFinite(n)) return '₹0';
    const rounded = Math.round(n * 100) / 100;
    if (Number.isInteger(rounded)) return `₹${rounded}`;
    return `₹${rounded.toFixed(2)}`;
}
